import React from 'react'

const Title = () => {
    return (
        <div className="w-full justify-start text-neutral-900 text-xl font-bold font-['Arial'] capitalize leading-loose">Table of contents</div>)
}

export default Title